// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'admin/core/store';
import {
    Icon,
    Item,
    Status,
    Translate,
} from '@plesk/ui-library';
import {
    DashboardItemContainer,
    ItemDescription,
    StatusContainer,
    StatusCount,
    StatusLinks,
} from 'admin/dashboard/containers/items/Styles';

export type ServerItemProps =
    ReturnType<typeof mapStateToProps>;

export const ServerItem: React.FC<ServerItemProps> = ({
    stats,
}) => (
    <DashboardItemContainer>
        <Item
            style={{ minHeight: '175px' }}
            icon={<Icon name="servers" intent="info" />}
            description={<ItemDescription>{stats.total}</ItemDescription>}
            view="card"
            title={<Translate content="dashboard.cards.servers" />}
        >
            <StatusContainer>
                <StatusLinks>
                    <Status intent="success" compact={true}>
                        <Translate content="computeResource.servers.statuses.started" />
                    </Status>
                    <Status intent="danger" compact={true}>
                        <Translate content="computeResource.servers.statuses.stopped" />
                    </Status>
                    <Status intent="inactive" compact={true}>
                        <Translate content="computeResource.servers.statuses.unavailable" />
                    </Status>
                </StatusLinks>
                <div>
                    <StatusCount>{stats.status.started}</StatusCount>
                    <StatusCount>{stats.status.stopped}</StatusCount>
                    <StatusCount>{stats.status.unavailable}</StatusCount>
                </div>
            </StatusContainer>
        </Item>
    </DashboardItemContainer>
);

const mapStateToProps = (state: RootState) => ({
    stats: state.dashboard.data.servers,
});

export default connect(mapStateToProps)(ServerItem);
